// Peças comuns aos 2 pedidos de associação entre sociedades de advogados
// (Contrato de Associação e Distrato de Associação): quantidade de sociedades
// (base da taxa), pergunta da seccional e a Certidão de Regularidade condicional.

// Campos extras da "Identificação da Sociedade" (identificacaoSociedadeSection).
export const CAMPOS_ASSOCIACAO_SOCIEDADES = [
  { type: 'number', name: 'quantidadeSociedades', label: 'Quantidade de Sociedades Associadas', required: true, min: 2, step: 1, integer: true, placeholder: 'Mínimo 2' },
  {
    type: 'radio',
    name: 'sociedadeOutraSeccional',
    label: 'Alguma das sociedades é de outra seccional?',
    required: true,
    options: [{ value: 'SIM', label: 'Sim' }, { value: 'NAO', label: 'Não' }]
  }
];

export const CERTIDAO_REGULARIDADE_OUTRA_SECCIONAL = {
  id: 'certidaoRegularidade',
  tipoDocumentoProcesso: 561,
  name: 'Certidão de Regularidade',
  description: 'Certidão de regularidade da(s) sociedade(s) de outra seccional. Havendo mais de uma, juntar todas em arquivo único PDF',
  conditional: true,
  required: true,
  dependsOn: { field: 'sociedadeOutraSeccional', value: 'SIM' }
};

// R$ 102,00 por sociedade, mínimo de 2: o valor base (R$ 204,00) já inclui as
// 2 primeiras, e cada sociedade a mais soma R$ 102,00 (ver quantityPricing em
// pagamentoService.js).
export const PAGAMENTO_POR_SOCIEDADE = {
  amount: 204.00,
  quantityPricing: {
    quantityField: 'quantidadeSociedades',
    unitAmount: 102.00,
    baseQuantity: 2
  }
};
